/* eslint-disable no-constant-condition */
import { useCallback, useRef } from 'react';

import { Icon } from '../../common/Icon/Icon';
import useModal from '../../core/hooks/useModal';
import { Charger, ChargerAssessment } from '../../core/models';
import ChargerDetails from '../ChargerDetails/ChargerDetails';
import './AdminChargerInfoCard.css';

interface Props {
  onClick: () => void;
  selected: boolean;
  isHot: boolean;
  item: Charger;
  atProperty?: boolean;
  assessment?: ChargerAssessment;
}

function assessmentBadgeClass(assessment: ChargerAssessment): string {
  if (assessment.action === 'needs_review') return 'admin-info-card__ai-badge--review';
  if (assessment.verdict === 'on') return 'admin-info-card__ai-badge--on';
  if (assessment.verdict === 'off') return 'admin-info-card__ai-badge--off';
  return 'admin-info-card__ai-badge--uncertain';
}

function assessmentLabel(assessment: ChargerAssessment): string {
  if (assessment.action === 'needs_review') return 'Needs review';
  if (assessment.action === 'auto_confirmed') return 'AI on';
  if (assessment.verdict === 'off') return 'AI off';
  return 'Uncertain';
}

export function AdminChargerInfoCard({
  onClick,
  selected,
  isHot,
  item,
  atProperty,
  assessment,
}: Props) {
  const btnRef = useRef(null);
  const { modal, open } = useModal();

  // either we passed a custom action, or this opens its modal
  const clickAction = onClick || open;

  const openModal = useCallback(() => {
    if (!btnRef.current) return;
    open(btnRef.current);
  }, [btnRef.current]);

  const confidencePct = assessment != null ? Math.round(assessment.confidence * 100) : null;

  return (
    <>
      <div
        className={`admin-info-card${selected ? ` admin-info-card--selected` : ''}${
          isHot ? ' hover' : ''
        }${assessment?.action === 'needs_review' ? ' admin-info-card--needs-review' : ''}`}
      >
        <button
          className="admin-info-card__modal-btn"
          type="button"
          ref={btnRef}
          onClick={openModal}
        >
          <span className="admin-info-card__title h4">{item.owner.name}</span>
          {false ? (
            <span className="admin-info-card__access_type caption">
              {`${item.access_type} charger`}
            </span>
          ) : null}
          {!atProperty ? (
            <address className="admin-info-card__address caption">{item.address}</address>
          ) : null}
          {assessment ? (
            <span
              className={`admin-info-card__ai-badge ${assessmentBadgeClass(assessment)}`}
              title={assessment.reason}
            >
              {assessmentLabel(assessment)}
              {confidencePct != null ? ` ${confidencePct}%` : ''}
            </span>
          ) : null}
        </button>
        <button className="admin-info-card__select-btn" type="button" onClick={clickAction}>
          <span className="sr-only">Confirm charger {item.owner.name}</span>
          {selected ? (
            <Icon.Checkmark className="icon-small" />
          ) : (
            <Icon.Plus className="icon-small" />
          )}
        </button>
      </div>
      {modal({
        children: <ChargerDetails item={item} atProperty={atProperty} />,
      })}
    </>
  );
}
